import mdgw from 'format4js';

class RetailerIdFormat {
  constructor(appFactory) {
    this.retailerIdPattern = appFactory.deps.config.retailerId ? appFactory.deps.config.retailerId.pattern : '';
    return (value) => this.retailerIdPattern ? isNaN(value) ? value : mdgw.format(this.retailerIdPattern, value) : value;
  }
}
RetailerIdFormat.$inject = ['appFactory'];

export default RetailerIdFormat;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-filters/retailerId-format-filter.js